import React from 'react'
import PropTypes from 'prop-types'
import { compose, mapProps } from 'recompose'
import FormImageElement from './FormImageElement'
import { updateObject } from 'helpers/objectHelpers'
import HoverBar from 'components/hover/HoverBar'
import { withSortableCollection } from 'hocs/bases/withSortableCollection'
import { initialSingleImage } from 'helpers/initialState'

const FormMultiImages = compose(
  mapProps(({ value, onChange, ...props }) => ({
    collection: value,
    onUpdate: onChange,
    ...props,
  })),
  withSortableCollection({
    dataSet: initialSingleImage,
  }),
)(
  ({
    index,
    item,
    onReplaceItemByIndex,
    onDeleteByIndex,
    isHorizontal,
  }) => {
    const handleChange = (val) => {
      return onReplaceItemByIndex(index, val)
    }
    return (
      <HoverBar
        icons={[
          { icon: 'fa fa-trash', onClick: () => onDeleteByIndex(index)},
        ]}
      >
        <FormImageElement
          isHorizontal={isHorizontal}
          value={item}
          style={{ marginBottom: 10 }}
          onChange={handleChange}
        >
          <FormImageElement.ActiveSwitch
            value={item.active}
            onChange={(val) => handleChange(updateObject(item, { active: val }))}
          />
        </FormImageElement>
      </HoverBar>
    )
  },
)

FormMultiImages.propTypes = {
  isHorizontal: PropTypes.bool,
}
FormMultiImages.defaultProps = {
  isHorizontal: true
}

export default FormMultiImages



// WEBPACK FOOTER //
// ./src/components/forms/image/FormMultiImages.js